import { useLocation } from "react-router-dom";

export function usePortalPath() {
  const { pathname } = useLocation();

  const isLandlordPath = /^\/[^/]+\/landlord/.test(pathname);
  const isTenantPath = /^\/[^/]+\/tenant/.test(pathname);
  const isVendorPath = /^\/[^/]+\/listing/.test(pathname);
  const isLandlordOrTenantPath = isLandlordPath || isTenantPath;

  return {
    isLandlordOrTenantPath,
    isLandlordPath,
    isTenantPath,
    isVendorPath,
  };
}
